module.exports = __webpack_public_path__ + "media/images/tto-logo-e96bc9264d6a711f0b21a8c2e2ac4948.png";